// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baseTypeSkeletonCss_b7qqja7{border-radius:1000000px;display:inline-block;height:0.7em;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/skeleton/TypeSkeletons.css"],"names":[],"mappings":"AAAA,6BAA6B,uBAAuB,CAAC,oBAAoB,CAAC,YAAY,CAAC","sourcesContent":[".baseTypeSkeletonCss_b7qqja7{border-radius:1000000px;display:inline-block;height:0.7em;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
